// src/pages/Contact.jsx
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Contact.css';

const Contact = () => {
    const form = useRef();
    const [submitted, setSubmitted] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_p09yn3m',     // 👈 replace this
            'template_r4maga9',    // 👈 replace this
            form.current,
            'YxzhDA2WZ4wZM-KBP8nlu'      // 👈 replace this
        )
            .then((result) => {
                console.log(result.text);
                setSubmitted(true);
            }, (error) => {
                console.log(error.text);
            });

        e.target.reset();
    };

    return (
        <section id="contact" className="contact-section">
            <h2 className="section-title">Contact Us</h2>
            <form ref={form} onSubmit={sendEmail} className="contact-form">
                <input type="text" name="user_name" placeholder="Your Name" required />
                <input type="email" name="user_email" placeholder="Your Email" required />
                <textarea name="message" placeholder="Your Message" required />
                <button type="submit">Send Message</button>
                {submitted && <p className="confirmation">Thank you! We'll be in touch.</p>}
            </form>
        </section>
    );
};

export default Contact;
